export const vacationIndicatorData = (target, requests) => {
  const teamVaccationData = [];
  for (let i = 1; i < target.length; i++) {
    target[i].childNodes.forEach((node) => {
      const userData = {
        name: null,
        target: null,
        date: null,
        status: null,
        vacationType: null
      }
      const teamVacationIndicatorData = {
        employees: [],
        target: null,
        date: null
      };

      if (node.attributes['data-is-focusable']) {
        node.attributes['data-is-focusable'].value = 'false';
      }

      for (let i = 0; i < requests.length; i++) {
        const isRestricted = !node.className.includes('dayOutsideBounds');
        const currentDate = new Date(node.childNodes[0].ariaLabel).toString();

        if (requests[i].dates.has(currentDate) && isRestricted) {
          const dateString = node.childNodes[0].ariaLabel;
          if (requests[i].name === 'currentUser') {
            userData.vacationType = requests[i].vacation_type;
            userData.status = requests[i].status;
            userData.target = node.childNodes[0];
            userData.date = dateString;
            userData.name = requests[i].name;
          } else {
            teamVacationIndicatorData.employees.push({
              name: requests[i].name,
              colorPersona: requests[i].colorPersona,
              backgroundPersona: requests[i].backgroundPersona,
            });
            teamVacationIndicatorData.target = node.childNodes[0];
            teamVacationIndicatorData.date = dateString;
          }
        }
      }

      if (teamVacationIndicatorData.target || userData.target) {
        teamVaccationData.push({
          data: teamVacationIndicatorData.employees,
          target: teamVacationIndicatorData.target,
          date: teamVacationIndicatorData.date,
          currentUserIndicatorData: {
            target: userData.target,
            date: userData.date,
            status: userData.status,
            vacationType: userData.vacationType,
            name: userData.name,
          },
        });
      }
    });
  }

  return teamVaccationData;
};
